import * as SharedAcross from '../utilities/SharedAcross';
import React, {useState, useEffect} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import { Icon } from '@iconify/react';

function App(props) {

  var selectFn = props.selectFn;
  var currentIcon = props.currentIcon;
  var columnWidthReal = props.columnWidthReal;

  var columnWidth = 90;

  if (!currentIcon){
    currentIcon = '';
  }

  const [value, setValue] = useState(currentIcon);
  const [icons, setIcons] = useState([]);
  const [haveLoaded, setHaveLoaded] = useState(false);


  function refreshImages(){
    function postGetPalette(response){
      if (response.t === 'list'){
        setIcons(response.v);
        setHaveLoaded(true);

      }
    }
    ServerComms.fetchSomething({u:'getIcons'}, postGetPalette);
  }
  useEffect(() => {
    refreshImages();
   }, []); // eslint-disable-line react-hooks/exhaustive-deps


    var placeholder = 'ant-design:smile-outlined';

    function clickHere(e){
      window.open('https://icon-sets.iconify.design/');
    }
  //
      
    function clickSubmit(e){
      selectFn(value);
    }

    function clickRemove(e){
      selectFn('');
      setValue('');
    }

    function clickSelect(value1){
      return function(e){
        selectFn(value1);
        setValue(value1);
      }
    }

    function onChange(e){
      setValue(e.target.value);    
    }
      // changeFn = onChangeSomething('raw', 'icon', []);

      var nos = Math.floor((columnWidthReal + 91)/columnWidth);
      if (nos === 0){
        nos = 1;
      }

    var iconSelect = null;
    if (haveLoaded){
      var grid = SharedAcross.convertToGrid(icons, nos, true);
      var rows = grid.map((aRow, index)=>{
        var cells = aRow.map((aCell, index2)=>{
          if (aCell){
            var className = 'sCellLight';
            var url = aCell.v[1].v;
            if (url === currentIcon){
              className = "sCell";
            }
            var item =  <Icon height = "20" icon={aCell.v[1].v} /> 
            return <td style={{width:columnWidth * 0.9*0.8, maxWidth:columnWidth * 0.9 * 0.8, overflow:'scroll', textAlign:"center", cursor:'pointer'}} key={index2} onClick={clickSelect(url)} className={className} >{item}</td>
    //
          }else{
            return <td style={{width:"25%"}} key={index2}></td>
    //
          }
        })
        return <tr key={index}>{cells}</tr>
      })    
      iconSelect = <table width={columnWidth*0.9}><tbody>{rows}</tbody></table>
    }
  //
    var removeIcon;
    if (currentIcon){
      removeIcon = <button className='btn btn-secondary'  style={{margin:'5px'}} onClick={clickRemove}>Remove</button>
    }

    return <div  style={{paddingLeft:5,paddingRight:5}} >
          Find icons from <span onClick={clickHere} style={{cursor:'pointer'}}><u>here</u>, or select from the list below</span><br/><br/>
            <input type='text'className='form-control' value={value} onChange={onChange} placeholder={placeholder}/><br/>
            <button className='btn btn-secondary' style={{margin:'5px'}} onClick={clickSubmit}>Submit</button>
            {removeIcon}
            <br/>
            {iconSelect}
          </div>
//

}


//
export default App;
